import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, forkJoin, map, mergeMap, of, tap } from 'rxjs';
import { DocPreviewUtilityService } from 'src/app/common/components/file-preview/doc-preview-utility.service';
import { ServicePathsSettings } from 'src/app/core/configuration/service-paths-settings';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { PdaAccessToken } from 'src/app/pda/utils/Service/pda-auth.service';
import { SectionsServiceTsService } from 'src/app/pda/utils/Service/sections.service.ts.service';

@Injectable({
  providedIn: 'root'
})
export class ActsServiceTsService {

  importDatiSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(
    private http: HttpClient,
    private sectionService: SectionsServiceTsService,
    private helpersService: HelpersService,
    private docUtilityService: DocPreviewUtilityService
  )  { }

  getAtti(idFascicoloPct) : Observable<any> {
    return this.http.get<any>(ServicePathsSettings.URL_GET_SECTIONS(idFascicoloPct, 'atti'));
  }

  importDocumenti(token: PdaAccessToken, idFascicolo: string, req: {idFascicoloPct: string, idAct: string, idListDocuments: string[]}): Observable<any>{

    let url = ServicePathsSettings.URL_IMPORT_DOCUMENTI_PCT
      .replace("{idFascicoloPct}", req.idFascicoloPct)
      .replace("{idAttoPct}",req.idAct);
    let request = { token: token, listaIdDocumenti: req.idListDocuments };
    return this.http.post<any>(url,request, {responseType: "text" as "json"}).pipe(
      mergeMap(() => this.sectionService.updatePCT(token,idFascicolo, "atti"))
    );
  }

  downloadDirettoDoc(token: PdaAccessToken, idFascicoloTlf: string, idDocumento: string, refId: string, registro: string){
    let request = { token: token, idFascicoloTlf: idFascicoloTlf, idDocumentoPct: idDocumento, refIdDocumento: refId, copiaOriginale: false, registro: registro }
    return this.http.post(
      ServicePathsSettings.URL_DOWNLOAD_DOCUMENTO_PDA,
      request,
      {
        responseType: 'arraybuffer',
        observe: 'response',
        withCredentials: true,
      }
    )
    .pipe(this.download_operator);

  }

  downloadViewDoc(token: PdaAccessToken, idFascicoloTlf: string, idDocumento: string, refId: string): Observable<Blob | null> {
    let request = { token: token, idFascicoloTlf: idFascicoloTlf, idDocumentoPct: idDocumento, refIdDocumento: refId, copiaOriginale: false };
    return this.http.post(
      ServicePathsSettings.URL_DOWNLOAD_DOCUMENTO_PDA,
      request,
      {
        responseType: 'arraybuffer',
        observe: 'response',
        withCredentials: true,
      }
    ).pipe(
      map((res: HttpResponse<any>) => {
        return new Blob([res.body], { type: 'application/pdf' });
      }),
    ) 
  }

  viewPrevieP7m(token: PdaAccessToken, idFascicoloTlf: string, idDocumento: string, refId: string): Observable<Blob | null> {
    let request = { token: token, idFascicoloTlf: idFascicoloTlf, idDocumentoPct: idDocumento, refIdDocumento: refId, copiaOriginale: false };
    return this.http.post(
      ServicePathsSettings.URL_PREVIEW_DOCUMENTO_PDA,
      request,
      {
        responseType: 'arraybuffer',
        observe: 'response',
        withCredentials: true,
      }
    ).pipe(
      map((res: HttpResponse<any>) => {
        const contentDisposition = res.headers.get('Content-Disposition');
        const { filename, extension } = this.docUtilityService.parseContentDisposition(contentDisposition);
        if(extension !== "pdf" && extension !== "eml" && extension !== "zip" && extension !== "p7m") {
          return null;
        };
        const mimeExtensionMap: { [key: string]: string } = {
          'pdf': 'application/pdf',
          'zip': 'application/zip', 
          'eml': 'message/rfc822',
          'p7m': 'application/pkcs7-mime',
        };
        return new Blob([res.body], { type: mimeExtensionMap[extension] });
      }),
    ) 
  }



  onNextImportDocumenti(){
    this.importDatiSubject.next(null);
  }

  download_operator(
    source$: Observable<HttpResponse<any>>
  ): Observable<HttpResponse<any>> {
    return source$.pipe(
      tap((res: HttpResponse<any>) => {
        const filename = res.headers
          .get('content-disposition')
          .split('filename=')[1];
        const blob = new Blob([res.body], {
          type: 'application/octet-stream',
        });
        const url = window.URL.createObjectURL(blob);
        const a = window.document.createElement('a');
        window.document.body.appendChild(a);
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
        window.document.body.removeChild(a);
      })
    );
  }

}
